/**
 * THE PRIMITIVES, in their own module.
 *
 * They live here rather than beside the first schema that needed them because
 * every other contract module imports them: when they sat in index.ts, and
 * index.ts re-exported the modules that used them, the cycle resolved to
 * `undefined` at load time and the whole package failed on its first `.nullable()`.
 * A leaf module has no such problem — nothing it imports can import it back.
 */
import { z } from "zod";
export const Uuid = z.string().uuid();
export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "YYYY-MM-DD");
export const Currency = z.string().regex(/^[A-Z]{3}$/, "ISO 4217");
//# sourceMappingURL=primitives.js.map